var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-divider m-default",style:({marginTop:`${_vm.my}px`})})
}
var staticRenderFns = []

export { render, staticRenderFns }